<template>
  <section class="batch-modify shipping-mode-batch">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" :disabled="locked" @click="$emit('back')">
          ‹ 返回
        </button>
        <span>
          商品工作台　›　批量修改　›　
          <strong>发货模式(SKU时效)</strong>
        </span>
      </div>
      <h1>批量修改发货模式(SKU时效)</h1>
      <nav>
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ active: mode === tab.value }"
          :disabled="locked"
          @click="switchMode(tab.value)"
        >
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main>
      <p v-if="optionsError" class="load-error">
        {{ optionsError }}
        <button class="plain" @click="loadOptions">重试加载</button>
      </p>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button :disabled="locked" @click="openSelector">选择商品</button>
          <span>
            已选择
            <b>{{ selected.length }}</b>
            个商品
          </span>
        </div>
        <div v-else-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label>
          <el-input
            v-model="idsText"
            :disabled="locked"
            type="textarea"
            :rows="3"
            placeholder="多个 ID 用逗号、空格或换行分隔，最多2000个"
          />
        </div>
        <div v-else class="filters" @keyup.enter="loadPreview(1)">
          <label v-for="field in shownFields" :key="field.key" class="field">
            <span>{{ field.label }}</span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categories"
              :disabled="locked"
            />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              :disabled="locked"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :disabled="locked">
                <el-option
                  v-for="o in field.matchOptions"
                  :key="o.value"
                  :value="o.value"
                  :label="o.label"
                />
              </el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filters[field.key + '_min']"
                  :disabled="locked"
                  placeholder="最小值"
                />
                <span>~</span>
                <input
                  v-model="filters[field.key + '_max']"
                  :disabled="locked"
                  placeholder="最大值"
                />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :disabled="locked"
                :placeholder="field.placeholder || '请输入' + field.label"
              />
            </div>
            <div v-else-if="field.range" class="range">
              <input
                v-model="filters[field.key + '_min']"
                :disabled="locked"
                placeholder="最小值"
              />
              <span>~</span>
              <input
                v-model="filters[field.key + '_max']"
                :disabled="locked"
                placeholder="最大值"
              />
            </div>
            <el-select
              v-else-if="field.options"
              v-model="filters[field.key]"
              :disabled="locked"
              clearable
            >
              <el-option
                v-for="o in field.options"
                :key="String(o.value)"
                :value="o.value"
                :label="o.label"
              />
            </el-select>
            <input
              v-else
              v-model="filters[field.key]"
              :disabled="locked"
              :placeholder="field.placeholder || '请输入条件'"
            />
          </label>
        </div>
        <footer class="filter-actions">
          <doudian-batch-shop-scope
            v-model="shops"
            :shops="shopOptions"
            :disabled="locked"
            @input="changeShops"
          />
          <div class="filter-buttons">
            <button :disabled="locked || loading" @click="loadPreview(1)">
              查询
            </button>
            <button class="plain" :disabled="locked" @click="resetFilters">
              重置
            </button>
          </div>
        </footer>
        <p class="hint">按本地数据筛选，执行时读取抖店详情复核。</p>
      </section>
      <doudian-batch-common-options
        v-model="commonOptions"
        :disabled="locked || loading"
      />
      <p class="hint">同步调整上下架随本次商品修改审核通过后生效。</p>
      <section class="panel methods freight-content">
        <h3>
          <i></i>
          修改内容
        </h3>
        <div class="method-body shipping-editor">
          <div class="shipping-row">
            <span>类目可配置时效查询：</span>
            <el-select
              v-model="capabilityShop"
              clearable
              placeholder="选择提示店铺"
              :disabled="locked"
            >
              <el-option
                v-for="shop in shopOptions"
                :key="shop.mer_shop_id"
                :value="shop.mer_shop_id"
                :label="shop.shop_name"
              />
            </el-select>
            <el-cascader
              v-model="capabilityCategory"
              :options="categories"
              :props="{
                value: 'category_id',
                label: 'category_name',
                children: 'children',
                emitPath: false,
              }"
              clearable
              filterable
              placeholder="选择提示类目"
              :disabled="locked"
            />
            <button
              :disabled="
                locked ||
                capabilityLoading ||
                !capabilityShop ||
                !capabilityCategory
              "
              @click="loadCapabilities"
            >
              查询
            </button>
          </div>
          <div
            v-if="capabilityData || capabilityError"
            class="shipping-capability-results"
          >
            <div class="shipping-capability-heading">查询结果</div>
            <div
              v-for="item in capabilityRows"
              :key="item.label"
              class="shipping-capability-item"
            >
              <strong>{{ item.label }}</strong>
              <span :class="['shipping-capability-status', item.status]">
                {{ item.statusText }}
              </span>
              <span v-if="item.detail">{{ item.detail }}</span>
            </div>
          </div>
          <p class="hint">
            选择店铺和类目后查询该类目可配置的发货时效；批量执行仍逐商品复核。<span v-if="capabilityData || capabilityError">此结果仅适用于所选店铺和类目，不会自动更改已选值。</span>
          </p>
          <el-radio-group
            v-model="shipping.operation"
            class="shipping-method-list"
            :disabled="locked"
          >
            <section
              v-for="operation in operations"
              :key="operation.value"
              class="shipping-method"
            >
              <el-radio
                :label="operation.value"
                class="shipping-method-title"
                >{{ operation.label }}</el-radio
              >
              <div class="shipping-method-options">
                <div
                  v-if="operation.value !== 'set_presale'"
                  class="shipping-field-row"
                >
                  <span class="shipping-field-label">现货发货时间：</span>
                  <div class="shipping-row">
                    <el-select
                      v-model="shipping[operation.spotDayField]"
                      :disabled="locked"
                    >
                      <el-option :value="9999" label="当日发" />
                      <el-option :value="1" label="次日发" />
                      <el-option :value="2" label="48小时发" />
                    </el-select>
                    <div
                      v-if="operation.value === 'set_mixed_stock'"
                      class="shipping-row"
                    >
                      <span>现货库存为原现货库存的</span>
                      <el-input-number
                        v-model="shipping.spotPercent"
                        :disabled="locked"
                        :min="0"
                        :max="100"
                        :precision="0"
                      />
                      <span>%</span>
                    </div>
                    <div
                      v-if="operation.value === 'set_spot'"
                      class="shipping-row"
                    >
                      <span>春节／特殊日期延迟发货：</span>
                      <el-radio-group
                        v-model="shipping.holidayAction"
                        :disabled="locked"
                      >
                        <el-radio label="keep">保持不变</el-radio>
                        <el-radio label="disable">关闭</el-radio>
                        <el-radio label="set">统一设置</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <template
                  v-if="
                    operation.value === 'set_spot' &&
                    shipping.holidayAction === 'set'
                  "
                >
                  <div class="shipping-field-row shipping-holiday-times">
                    <span class="shipping-field-label">下单时间：</span>
                    <div class="shipping-row">
                      <el-date-picker
                        v-model="shipping.holidayStartAt"
                        :disabled="locked"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="下单开始时间（北京时间）"
                      />
                      <span>至</span>
                      <el-date-picker
                        v-model="shipping.holidayEndAt"
                        :disabled="locked"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="下单结束时间（北京时间）"
                      />
                      <span>最晚发货时间</span>
                      <el-date-picker
                        v-model="shipping.holidayLatestAt"
                        :disabled="locked"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="最晚发货时间（北京时间）"
                      />
                      <el-tooltip
                        content="适用活动、可选时间及发货天数以抖店当前规则为准；店铺级设置需到抖店后台调整。"
                        placement="top"
                      >
                        <span class="shipping-rule-help" tabindex="0"
                          >查看规则</span
                        >
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="shipping-field-row">
                    <span class="shipping-field-label">按天数发货时：</span>
                    <el-radio-group
                      v-model="shipping.holidayRelativeAction"
                      :disabled="locked"
                    >
                      <el-radio label="days">统一设置为</el-radio>
                      <template
                        v-if="shipping.holidayRelativeAction === 'days'"
                      >
                        <el-input-number
                          v-model="shipping.holidayDays"
                          :disabled="locked"
                          :min="1"
                          :max="90"
                          :precision="0"
                        />
                        <span>天</span>
                      </template>
                      <el-radio label="fail">修改失败</el-radio>
                    </el-radio-group>
                  </div>
                  <p class="hint">
                    按天数配置时使用支付后天数；选择修改失败时，该商品不执行修改并记录失败原因。
                  </p>
                </template>
                <template v-if="operation.value === 'set_presale'">
                  <el-radio-group
                    v-model="shipping.endMode"
                    :disabled="locked"
                    class="shipping-presale-options"
                  >
                    <div class="shipping-presale-line">
                      <el-radio label="fixed">预售结束时间</el-radio>
                      <div
                        v-if="shipping.endMode === 'fixed'"
                        class="shipping-row"
                      >
                        <el-date-picker
                          v-model="shipping.endAt"
                          :disabled="locked"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择北京时间"
                        />
                        <span>预售发货时间：</span>
                        <el-select v-model="shipping.basis" :disabled="locked">
                          <el-option value="end" label="预售结束后" />
                          <el-option value="payment" label="支付成功后" />
                        </el-select>
                        <el-input-number
                          v-model="shipping.delayDays"
                          :disabled="locked"
                          :min="2"
                          :max="90"
                          :precision="0"
                        />
                        <span>天内发货</span>
                      </div>
                    </div>
                    <div class="shipping-presale-line">
                      <el-radio label="none">无结束时间</el-radio>
                      <div
                        v-if="shipping.endMode === 'none'"
                        class="shipping-row"
                      >
                        <span>支付成功后</span>
                        <el-input-number
                          v-model="shipping.delayDays"
                          :disabled="locked"
                          :min="2"
                          :max="90"
                          :precision="0"
                        />
                        <span>天内发货</span>
                      </div>
                    </div>
                  </el-radio-group>
                  <p class="hint">
                    结束时间须为未来30天内；发货天数为候选输入范围，实际可用范围以抖店校验为准。
                  </p>
                </template>
                <div
                  v-if="operation.value === 'set_sku_timeliness'"
                  class="shipping-field-row"
                >
                  <span class="shipping-field-label">预售发货时间：</span>
                  <el-checkbox-group
                    v-model="shipping.skuDays"
                    class="shipping-time-options"
                    :disabled="locked"
                  >
                    <el-checkbox
                      v-for="tier in shipping.tiers"
                      :key="tier.days"
                      :label="tier.days"
                    >
                      {{ tier.days }}天内发货
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="operation.value === 'set_mixed_stock'"
                  class="shipping-field-row"
                >
                  <span class="shipping-field-label">预售发货时间：</span>
                  <div class="shipping-tiers">
                    <div
                      v-for="tier in shipping.tiers"
                      :key="tier.days"
                      class="shipping-tier"
                    >
                      <el-checkbox v-model="tier.enabled" :disabled="locked"
                        >{{ tier.days }}天内发货</el-checkbox
                      >
                      <div v-if="tier.enabled" class="shipping-tier-options">
                        <el-radio-group
                          v-model="tier.kind"
                          :disabled="locked"
                          class="shipping-stock-options"
                        >
                          <div class="shipping-row">
                            <el-radio label="ratio"
                              >库存为计算后现货库存的</el-radio
                            >
                            <el-input-number
                              v-if="tier.kind === 'ratio'"
                              v-model="tier.percent"
                              :disabled="locked"
                              :min="0"
                              :max="1000"
                              :precision="0"
                            />
                            <span v-if="tier.kind === 'ratio'">%</span>
                          </div>
                          <div class="shipping-row">
                            <el-radio label="fixed">库存统一设为</el-radio>
                            <el-input-number
                              v-if="tier.kind === 'fixed'"
                              v-model="tier.quantity"
                              :disabled="locked"
                              :min="0"
                              :max="999999"
                              :precision="0"
                            />
                            <span v-if="tier.kind === 'fixed'">件</span>
                          </div>
                        </el-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
                <p v-if="operation.value === 'set_sku_timeliness'" class="hint">
                  每新增一个预售时效，库存按对应现货SKU复制一份，价格和SKU编码沿用现货；总库存会增加。已有但未选的预售档将清零。
                </p>
                <p
                  v-if="
                    operation.value === 'set_presale' &&
                    shipping.endMode === 'fixed'
                  "
                  class="hint"
                >
                  新版混合商品转为有结束时间的预售时，每个SKU的现货和全部预售库存合并，原预售档清零，总库存保持不变。
                </p>
                <p v-if="operation.value === 'set_spot'" class="hint">
                  预售转回现货保留当前现货库存；新版混合商品的全部预售档清零，不合并预售库存，价格和SKU编码保持。
                </p>
                <p
                  v-if="
                    operation.value === 'set_presale' &&
                    shipping.endMode === 'none'
                  "
                  class="hint"
                >
                  无截止预售按支付后天数发货，将SKU总库存转入所选时效，现货库存设为0，库存总量保持不变。
                </p>
                <p v-if="operation.value === 'set_mixed_stock'" class="hint">
                  每个SKU分别计算；预售比例以计算后的现货库存为基数，各档独立设置，向下取整，不分配剩余库存。已有但未选的预售档将清零，目标总库存可能增加，请查看库存测算。
                </p>
                <p
                  v-if="
                    ['set_sku_timeliness', 'set_mixed_stock'].includes(
                      operation.value
                    )
                  "
                  class="hint"
                >
                  来源为普通商品级预售时，以该SKU原预售库存作为计算起点，再按上述复制、比例或固定数量规则处理。
                </p>
              </div>
            </section>
          </el-radio-group>
          <p class="hint">
            执行前先核验各店铺所选类目的预售资格，不支持的自动跳过；支持普通现货与新版时效库存，旧规格迁移或受锁商品会说明原因。请确认备货能力。
          </p>
        </div>
      </section>
      <section v-if="preview" class="panel preview">
        <header class="preview-summary">
          <span>
            候选
            <b>{{ preview.total }}</b>
            个，已排除 {{ preview.excluded_total }} 个，本次提交
            {{ preview.selected_total }} 个；本页预计命中
            {{ counts.ready }}、预计跳过 {{ counts.skipped }}、待核验
            {{ counts.unknown }}、预计失败 {{ counts.failed }}
          </span>
          <button class="plain" :disabled="locked" @click="invalidate">
            收起预览
          </button>
        </header>
        <p class="hint">
          预览依据本地快照，实际命中和修改结果以执行时抖店详情复核及平台回执为准。
        </p>
        <p
          v-if="
            preview.missing_product_ids && preview.missing_product_ids.length
          "
          class="load-error"
        >
          本地未匹配或不属于当前店铺的商品 ID：{{
            preview.missing_product_ids.join("、")
          }}
        </p>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>商品信息</th>
                <th>原发货模式(SKU时效)方式</th>
                <th>目标发货模式(SKU时效)方式</th>
                <th>预览结果</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in preview.list"
                :key="item.id"
                :class="{ excluded: excluded.includes(Number(item.id)) }"
              >
                <td>
                  <div class="preview-product">
                    <img
                      v-if="item.main_image"
                      class="preview-product-image"
                      :src="item.main_image"
                      alt="商品主图"
                    />
                    <div>
                      {{ item.product_title }}
                      <small>
                        {{ item.shop_name }}
                        <br />
                        {{ item.platform_product_id }}
                      </small>
                    </div>
                  </div>
                </td>
                <td>
                  {{ shippingLabel(item.old_values) }}
                </td>
                <td>
                  {{ shippingLabel(item.target_values) }}
                </td>
                <td>
                  {{ resultLabels[item.preview_result] || "待核验" }}
                  <small>{{ item.reason_text }}</small>
                </td>
                <td>
                  <button
                    v-if="
                      ['set_sku_timeliness', 'set_mixed_stock'].includes(
                        shipping.operation
                      ) ||
                      (shipping.operation === 'set_presale' &&
                        shipping.endMode === 'none') ||
                      (['set_spot', 'set_presale'].includes(
                        shipping.operation
                      ) &&
                        item.old_values &&
                        Number(item.old_values.presell_type) === 2)
                    "
                    class="plain"
                    :disabled="locked || skuLoading"
                    @click="showSku(item, 1)"
                  >
                    库存测算
                  </button>
                  <el-checkbox
                    :value="excluded.includes(Number(item.id))"
                    :disabled="locked || loading"
                    @change="exclude(item.id, $event)"
                  >
                    排除修改
                  </el-checkbox>
                </td>
              </tr>
              <tr v-if="!preview.list.length">
                <td colspan="5" class="empty">暂无符合条件的商品</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :disabled="locked || loading"
            :current-page="preview.page"
            :page-size="preview.limit"
            :total="preview.total"
            @current-change="loadPreview"
          />
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button
        class="preview-button"
        :disabled="locked || loading"
        @click="loadPreview(1)"
      >
        {{ loading ? "加载中…" : "修改内容预览" }}
      </button>
      <button
        v-if="createUncertain"
        class="start"
        :disabled="submitting"
        @click="submitFrozen"
      >
        确认创建结果
      </button>
      <button
        v-else
        class="start"
        :disabled="locked || loading || !canSubmit"
        @click="createBatch"
      >
        {{ submitting ? "创建中…" : "开始批量修改" }}
      </button>
      <label>
        <input v-model="scheduled" type="checkbox" :disabled="locked" />
        定时执行
      </label>
      <el-date-picker
        v-if="scheduled"
        v-model="scheduledAt"
        :disabled="locked"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="选择北京时间"
      />
    </footer>
    <el-dialog
      title="SKU库存测算（本地预览）"
      :visible.sync="skuVisible"
      width="90%"
      @close="closeSku"
    >
      <p v-if="skuLoading">正在读取…</p>
      <template v-if="skuPreview">
        <p>
          原库存合计 {{ skuPreview.stock_summary.before }} → 目标合计
          {{ skuPreview.stock_summary.target }}，变化
          {{
            skuPreview.stock_summary.delta
          }}。基于本地数据测算，执行时会按实时库存、店铺类目资格及商品锁再次核验。
        </p>
        <el-table :data="skuPreview.list" max-height="420">
          <el-table-column
            prop="source_sku_id"
            label="来源SKU"
            min-width="190"
          />
          <el-table-column label="价格（元，沿用）" min-width="130">
            <template slot-scope="scope">
              {{
                scope.row.price == null
                  ? "待核验"
                  : (Number(scope.row.price) / 100).toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            label="SKU编码（沿用）"
            min-width="150"
          />
          <el-table-column prop="days" label="时效值" />
          <el-table-column label="计算方式" min-width="120">
            <template slot-scope="scope">
              {{
                {
                  spot: "现货",
                  copy: "复制现货",
                  ratio: "按比例",
                  fixed: "固定数量",
                  transfer: "总库存转入",
                  clear: "清零原档",
                }[scope.row.kind] || scope.row.kind
              }}
            </template>
          </el-table-column>
          <el-table-column prop="base_stock" label="计算基数" />
          <el-table-column prop="old_stock" label="原库存" />
          <el-table-column prop="target_stock" label="目标库存" />
        </el-table>
        <el-pagination
          :current-page="skuPreview.page"
          :page-size="20"
          :total="skuPreview.total"
          layout="prev, pager, next"
          @current-change="showSku(skuProduct, $event)"
        />
      </template>
    </el-dialog>
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="
        selectorRows.length > 0 && selectorRows.every(isSelected)
      "
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @close="closeSelector"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = $event"
      @jump="changeSelectorPage(Number(selectorJump))"
      @confirm="confirmSelected"
    >
      <template #filters>
        <doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)"
        />
      </template>
    </product-selector-dialog>
  </section>
</template>

<script>
import {
  previewDoudianShippingModeBatch,
  createDoudianShippingModeBatch,
  previewDoudianShippingModeSkus,
  getDoudianCategories,
  getDoudianShippingModeShops,
  getDoudianShippingModeCapabilities,
  getProductSelectorProducts,
} from "@/api/main/doudianBatchEdit";
import DoudianCategoryCascader from "@/components/DoudianCategoryCascader";
import DoudianBatchShopScope from "@/components/DoudianBatchShopScope";
import ProductSelectorDialog from "@/components/ProductSelectorDialog/ProductSelectorDialog";
import DoudianBatchCommonOptions from "@/components/DoudianBatchCommonOptions";
import DoudianProductSelectorFilters from "./DoudianProductSelectorFilters.vue";
import {
  fields,
  pairedFields,
  defaults,
  buildBatchProductFilter,
} from "./batchModifyFilters";

const selectorDefaults = () => ({
  category_id: { level1: [], level2: [], level3: [] },
  platform_product_id: "",
  product_title: "",
  created_at: [],
  tab_status: "",
});
const supportedFields = fields.filter(
  (field) => !["quality", "has_exposure"].includes(field.key)
);

export default {
  name: "BatchModifyShippingMode",
  components: {
    DoudianCategoryCascader,
    DoudianBatchShopScope,
    ProductSelectorDialog,
    DoudianBatchCommonOptions,
    DoudianProductSelectorFilters,
  },
  data: () => ({
    tabs: [
      { value: "range", label: "按范围修改" },
      { value: "products", label: "按商品修改" },
      { value: "product_ids", label: "按商品 ID 修改" },
    ],
    mode: "range",
    filters: defaults(),
    shops: [],
    selectorShopId: "",
    shopOptions: [],
    categories: [],
    optionsLoading: false,
    optionsError: "",
    capabilityShop: "",
    capabilityCategory: null,
    capabilityLoading: false,
    capabilityRequest: 0,
    capabilityData: null,
    capabilityError: "",
    operations: [
      { value: "set_spot", label: "统一改为现货", spotDayField: "spotDay" },
      { value: "set_presale", label: "统一改为预售" },
      {
        value: "set_sku_timeliness",
        label: "SKU发货时效",
        spotDayField: "skuSpotDay",
      },
      {
        value: "set_mixed_stock",
        label: "现货预售混合",
        spotDayField: "mixedSpotDay",
      },
    ],
    shipping: {
      operation: "set_spot",
      spotDay: 9999,
      skuSpotDay: 9999,
      mixedSpotDay: 9999,
      skuDays: [],
      spotPercent: 100,
      holidayAction: "keep",
      holidayStartAt: "",
      holidayEndAt: "",
      holidayLatestAt: "",
      holidayRelativeAction: "days",
      holidayDays: 3,
      endMode: "fixed",
      endAt: "",
      basis: "end",
      delayDays: 7,
      tiers: [3, 4, 5, 7, 10, 15, 20, 25, 30, 35, 45].map((days) => ({
        days,
        enabled: false,
        kind: "ratio",
        percent: 100,
        quantity: 0,
      })),
    },
    skuVisible: false,
    skuLoading: false,
    skuPreview: null,
    skuProduct: null,
    skuRequest: 0,
    selected: [],
    excluded: [],
    idsText: "",
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: "",
    preview: null,
    signature: "",
    loading: false,
    previewRequest: 0,
    requestId: "",
    confirming: false,
    submitting: false,
    createUncertain: false,
    frozenBody: null,
    selectorVisible: false,
    selectorTab: "all",
    selectorLoading: false,
    selectorRows: [],
    selectorPageSize: 20,
    selectorPage: 1,
    selectorTotal: 0,
    selectorJump: 1,
    selectorFilters: selectorDefaults(),
    draftSelected: [],
    selectorRequest: 0,
    resultLabels: {
      ready: "预计命中",
      skipped: "预计跳过",
      unknown: "待核验",
      failed: "预计失败",
    },
  }),
  computed: {
    capabilityRows() {
      if (this.capabilityError) {
        return [{
          label: "查询状态",
          status: "unknown",
          statusText: "查询失败",
          detail: this.capabilityError,
        }];
      }
      const data = this.capabilityData;
      if (!data) return [];
      const statusText = (value) => ({
        conditional: "支持，提交时逐商品复核",
        unsupported: "不支持",
        unknown: "待核验",
      }[value] || "待核验");
      const dayList = (values) => Array.isArray(values) && values.length
        ? values.map((item) => typeof item === "object"
          ? item.time_desc || `${item.time_type}天内发货`
          : ({ 9999: "当日发", 1: "次日发", 2: "48小时发" }[item] || `${item}天内发货`)
        ).join("、")
        : "平台未返回可选时效";
      const step = data.timeliness_rule || {};
      const presale = data.product_presell_rule || {};
      const config = presale.delivery_after_pay_config || {};
      const fixedStatus = data.operations?.set_presale || "unknown";
      const fixedDetail = fixedStatus === "conditional"
        ? `发货天数${config.min_delivery_days ?? "待核验"}—${config.max_delivery_days ?? "待核验"}天；预售结束最长${config.max_presell_end_days ?? "待核验"}天；门槛价${presale.min_presell_price == null ? "待核验" : `${(Number(presale.min_presell_price) / 100).toFixed(2)}元`}`
        : "";
      return [
        { label: "固定结束预售", status: fixedStatus, statusText: statusText(fixedStatus), detail: fixedDetail },
        { label: "SKU时效预售", status: data.operations?.set_sku_timeliness || "unknown", statusText: statusText(data.operations?.set_sku_timeliness), detail: dayList(step.multi_times) },
        { label: "现货预售混合", status: data.operations?.set_mixed_stock || "unknown", statusText: statusText(data.operations?.set_mixed_stock), detail: dayList(step.multi_times) },
        { label: "现货发货", status: data.operations?.set_spot || "unknown", statusText: statusText(data.operations?.set_spot), detail: dayList(data.normal_timeliness_rule?.delay_options) },
      ];
    },
    canSubmit() {
      return this.operations.some(
        (operation) => operation.value === this.shipping.operation
      );
    },
    locked() {
      return this.confirming || this.submitting || this.createUncertain;
    },
    shownFields() {
      return supportedFields
        .filter((f) => !Object.values(pairedFields).includes(f.key))
        .map((f) =>
          f.key === "stock" ? { ...f, label: "总库存范围（含预售，件）" } : f
        )
        .map((f) =>
          pairedFields[f.key]
            ? {
                ...f,
                matchKey: pairedFields[f.key],
                matchOptions: fields.find((x) => x.key === pairedFields[f.key])
                  .options,
              }
            : f
        );
    },
    previewCurrent() {
      return !!(
        this.preview && this.signature === JSON.stringify(this.payload(false))
      );
    },
    counts() {
      return (
        this.preview?.page_match_counts || {
          ready: 0,
          skipped: 0,
          unknown: 0,
          failed: 0,
        }
      );
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil(
          (this.selectorTab === "selected"
            ? this.draftSelected.length
            : this.selectorTotal) / this.selectorPageSize
        )
      );
    },
    selectorProducts() {
      return this.selectorTab === "selected"
        ? this.draftSelected.slice(
            (this.selectorPage - 1) * this.selectorPageSize,
            this.selectorPage * this.selectorPageSize
          )
        : this.selectorRows;
    },
  },
  watch: {
    capabilityShop() {
      this.clearCapabilities();
    },
    capabilityCategory() {
      this.clearCapabilities();
    },
    filters: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    commonOptions: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    shipping: {
      deep: true,
      handler() {
        this.invalidate();
      },
    },
    "shipping.endMode"(value) {
      if (value === "none") this.shipping.basis = "payment";
    },
    idsText() {
      this.invalidate();
    },
    scheduled() {
      if (!this.scheduled) this.scheduledAt = "";
      this.invalidate();
    },
    scheduledAt() {
      this.invalidate();
    },
  },
  mounted() {
    this.newRequestId();
    this.loadOptions();
  },
  beforeDestroy() {
    this.capabilityRequest++;
    this.previewRequest++;
    this.skuRequest++;
    this.selectorRequest++;
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size);
      this.selectorPage = 1;
      this.loadSelector(1);
    },
    clearCapabilities() {
      this.capabilityRequest++;
      this.capabilityLoading = false;
      this.capabilityData = null;
      this.capabilityError = "";
    },
    async loadCapabilities() {
      if (this.locked || !this.capabilityShop || !this.capabilityCategory)
        return;
      const request = ++this.capabilityRequest;
      this.capabilityLoading = true;
      this.capabilityData = null;
      this.capabilityError = "";
      try {
        const data = this.dataOf(
          await getDoudianShippingModeCapabilities({
            shop_id: this.capabilityShop,
            category_id: this.capabilityCategory,
          })
        );
        if (!this._isDestroyed && request === this.capabilityRequest)
          this.capabilityData = data;
      } catch (error) {
        if (!this._isDestroyed && request === this.capabilityRequest)
          this.capabilityError =
            "平台候选查询失败：" +
            this.message(error) +
            "；未判定为支持或不支持。";
      } finally {
        if (request === this.capabilityRequest) this.capabilityLoading = false;
      }
    },
    dataOf(response) {
      if (!response || Number(response.code) !== 200) {
        const error = new Error(response?.message || "请求失败");
        error.businessFailure = true;
        throw error;
      }
      return response.data;
    },
    message(error) {
      return error?.response?.data?.message || error?.message || "请求失败";
    },
    newRequestId() {
      this.requestId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        (c) => {
          const r = (Math.random() * 16) | 0;
          return (c === "x" ? r : (r & 3) | 8).toString(16);
        }
      );
    },
    invalidate() {
      this.closeSku();
      this.previewRequest++;
      this.preview = null;
      this.signature = "";
      this.loading = false;
      if (!this.locked) this.newRequestId();
    },
    async loadOptions() {
      this.optionsLoading = true;
      this.optionsError = "";
      try {
        const data = this.dataOf(await getDoudianShippingModeShops());
        if (this._isDestroyed) return;
        this.shopOptions = Array.isArray(data)
          ? data
          : data.list || data.data || [];
        const categories = this.dataOf(
          await getDoudianCategories({ shop_type: 1 })
        );
        if (this._isDestroyed) return;
        const map = (rows) =>
          rows.map((x) => {
            const { children: sourceChildren, ...category } = x;
            const children = map(sourceChildren || []);
            return {
              ...category,
              category_id: x.id || x.category_id,
              category_name: x.name || x.category_name,
              ...(children.length ? { children } : {}),
            };
          });
        this.categories = map(
          Array.isArray(categories)
            ? categories
            : categories.list || categories.data || []
        );
      } catch (error) {
        if (!this._isDestroyed) this.optionsError = this.message(error);
      } finally {
        if (!this._isDestroyed) this.optionsLoading = false;
      }
    },
    changeShops() {
      this.excluded = [];
      this.invalidate();
    },
    changeSelectorShop(id) {
      this.selectorShopId = id;
      this.loadSelector(1);
    },
    shippingLabel(values) {
      if (!values || values.presell_type == null) return "待核验/仅预览";
      if (Number(values.presell_type) === 0) {
        const delay = values.delay_rule;
        const holiday = !delay
          ? ""
          : delay.enable === false
          ? "；特殊日期：关闭"
          : delay.enable === true
          ? "；特殊日期：" +
            (Number(delay.config_type) === 2
              ? "支付后" + delay.config_value + "天发货"
              : "最晚" + this.holidayTime(delay.config_value) + "发货")
          : "；特殊日期：待核验";
        return (
          "现货：" +
          ({ 9999: "当日发", 1: "次日发", 2: "48小时发" }[
            values.delivery_delay_day
          ] || "待核验") +
          holiday
        );
      }
      if (Number(values.presell_type) === 1)
        return (
          "预售：" +
          (values.presell_end_time || "截止待核验") +
          "，" +
          (Number(values.presell_delivery_type) === 1 ? "付款后" : "结束后") +
          (values.presell_delay == null
            ? "待核验"
            : values.presell_delay + "天")
        );
      if (
        Number(values.presell_type) === 2 &&
        Array.isArray(values.spec_prices_v2)
      ) {
        const skus = values.spec_prices_v2;
        const days = [
          ...new Set(
            skus.flatMap((sku) =>
              (sku.multi_time_stocks || [])
                .filter((pool) => Number(pool.stock_num) > 0)
                .map((pool) => pool.time_type)
            )
          ),
        ];
        return (
          "现货预售混合：" +
          skus.length +
          "个SKU，预售时效" +
          (days.length ? days.join("、") + "天" : "暂无可售库存")
        );
      }
      return "特殊模式，执行时核验";
    },
    holidayTime(value) {
      const time = Number(value);
      return Number.isFinite(time) && time > 0
        ? new Date(time * 1000 + 8 * 3600000)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        : "待核验";
    },
    shippingRule() {
      const s = this.shipping,
        rule = { operation: s.operation };
      if (s.operation !== "set_presale")
        rule.spot_delivery_day =
          s[
            this.operations.find(
              (operation) => operation.value === s.operation
            ).spotDayField
          ];
      if (s.operation === "set_spot") {
        rule.holiday_action = s.holidayAction;
        if (s.holidayAction === "set") {
          rule.holiday_config = {
            start_at: s.holidayStartAt,
            end_at: s.holidayEndAt,
            latest_at: s.holidayLatestAt,
            relative_action: s.holidayRelativeAction,
            ...(s.holidayRelativeAction === "days"
              ? { days: s.holidayDays }
              : {}),
          };
        }
      }
      if (s.operation === "set_presale") {
        Object.assign(rule, {
          end_mode: s.endMode,
          delivery_basis: s.endMode === "none" ? "payment" : s.basis,
          delay_days: s.delayDays,
        });
        if (s.endMode === "fixed") rule.end_at = s.endAt;
      }
      if (s.operation === "set_sku_timeliness")
        rule.presale_days = [...s.skuDays];
      if (s.operation === "set_mixed_stock") {
        rule.spot_stock_percent = s.spotPercent;
        rule.presale_tiers = s.tiers
          .filter((t) => t.enabled)
          .map((t) => ({
            days: t.days,
            stock_rule:
              t.kind === "ratio"
                ? { kind: "ratio", base: "computed_spot", percent: t.percent }
                : { kind: "fixed", quantity: t.quantity },
          }));
      }
      return rule;
    },
    closeSku() {
      this.skuRequest++;
      this.skuVisible = false;
      this.skuPreview = null;
      this.skuLoading = false;
      this.skuProduct = null;
    },
    async showSku(item, page = 1) {
      if (this.locked || !item) return;
      const request = ++this.skuRequest,
        body = this.payload(false),
        signature = JSON.stringify(body);
      this.skuVisible = true;
      this.skuLoading = true;
      this.skuProduct = item;
      this.skuPreview = null;
      try {
        const result = this.dataOf(
          await previewDoudianShippingModeSkus({
            ...body,
            distribute_product_id: Number(item.id),
            page,
            limit: 20,
          })
        );
        if (
          request !== this.skuRequest ||
          signature !== JSON.stringify(this.payload(false)) ||
          this._isDestroyed
        )
          return;
        this.skuPreview = result;
      } catch (error) {
        if (request === this.skuRequest && !this._isDestroyed) {
          this.$message.error(this.message(error));
          this.closeSku();
        }
      } finally {
        if (request === this.skuRequest && !this._isDestroyed)
          this.skuLoading = false;
      }
    },
    payload(includeRequest = true) {
      let filter =
        this.mode === "range"
          ? buildBatchProductFilter(
              this.filters,
              this.shops,
              this.excluded,
              "range"
            )
          : {
              shop_ids:
                this.mode === "products"
                  ? this.selected.length
                    ? [Number(this.selected[0].shop_id)]
                    : []
                  : this.shops,
              excluded_product_ids: [...this.excluded],
              platform_product_id:
                this.mode === "products"
                  ? this.selected.map((x) => String(x.platform_product_id))
                  : [
                      ...new Set(
                        this.idsText.split(/[,，\s]+/).filter(Boolean)
                      ),
                    ],
            };
      delete filter.quality_min;
      delete filter.quality_max;
      delete filter.has_exposure;
      const body = {
        selection_mode: this.mode,
        product_filter: filter,
        shipping_rule: this.shippingRule(),
        common_options: { ...this.commonOptions },
      };
      if (includeRequest) {
        body.request_id = this.requestId;
        if (this.scheduled) body.scheduled_at = this.scheduledAt;
      }
      return body;
    },
    validate() {
      const s = this.shipping;
      if (this.mode === "product_ids" && this.shops.length !== 1)
        throw new Error("按商品ID修改须选择一家店铺");
      if (s.operation === "set_spot" && s.holidayAction === "set") {
        const dates = [s.holidayStartAt, s.holidayEndAt, s.holidayLatestAt].map(
          (value) =>
            value ? Date.parse(value.replace(" ", "T") + "+08:00") : NaN
        );
        if (dates.some((value) => !Number.isFinite(value)))
          throw new Error("请完整填写特殊日期的下单和最晚发货时间");
        if (
          dates[0] >= dates[1] ||
          dates[2] <= dates[1] ||
          dates[1] <= Date.now()
        )
          throw new Error(
            "下单开始须早于结束，最晚发货须晚于结束，结束时间须在未来"
          );
        if (
          s.holidayRelativeAction === "days" &&
          (!Number.isInteger(s.holidayDays) ||
            s.holidayDays < 1 ||
            s.holidayDays > 90)
        )
          throw new Error("特殊日期发货天数须为1至90的整数");
        if (
          this.scheduled &&
          this.scheduledAt &&
          dates[1] <= Date.parse(this.scheduledAt.replace(" ", "T") + "+08:00")
        )
          throw new Error("特殊日期下单结束时间必须晚于定时执行时间");
      }
      if (s.operation === "set_presale" && s.endMode === "fixed" && !s.endAt)
        throw new Error("请选择预售结束时间");
      if (
        (s.operation === "set_sku_timeliness" && !s.skuDays.length) ||
        (s.operation === "set_mixed_stock" && !s.tiers.some((t) => t.enabled))
      )
        throw new Error("请选择预售时效");
      if (this.mode === "products" && !this.selected.length)
        throw new Error("请选择商品");
      const ids = this.payload(false).product_filter.platform_product_id;
      if (
        this.mode === "product_ids" &&
        (!ids.length ||
          ids.length > 2000 ||
          ids.some((id) => !/^[1-9][0-9]{0,199}$/.test(id)))
      )
        throw new Error("请输入有效抖店商品 ID，最多2000个");
      if (
        this.selected.some(
          (x) => Number(x.shop_id) !== Number(this.selected[0].shop_id)
        )
      )
        throw new Error("只能选择同一家店铺的商品");
      if (
        this.scheduled &&
        (!this.scheduledAt ||
          !Number.isFinite(
            Date.parse(this.scheduledAt.replace(" ", "T") + "+08:00")
          ) ||
          Date.parse(this.scheduledAt.replace(" ", "T") + "+08:00") <=
            Date.now())
      )
        throw new Error("定时时间必须为未来的北京时间");
    },
    switchMode(mode) {
      if (this.locked || this.mode === mode) return;
      this.mode = mode;
      this.selected = [];
      this.excluded = [];
      this.idsText = "";
      this.closeSelector();
      this.invalidate();
    },
    async loadPreview(page = 1) {
      if (this.locked) return;
      try {
        this.validate();
      } catch (error) {
        return this.$message.warning(error.message);
      }
      const body = this.payload(false),
        signature = JSON.stringify(body),
        request = ++this.previewRequest;
      this.loading = true;
      try {
        const data = this.dataOf(
          await previewDoudianShippingModeBatch({ ...body, page, limit: 20 })
        );
        if (
          request !== this.previewRequest ||
          signature !== JSON.stringify(this.payload(false)) ||
          this._isDestroyed
        )
          return;
        this.preview = data;
        this.signature = signature;
      } catch (error) {
        if (request === this.previewRequest && !this._isDestroyed) {
          this.invalidate();
          this.$message.error(this.message(error));
        }
      } finally {
        if (request === this.previewRequest && !this._isDestroyed)
          this.loading = false;
      }
    },
    async createBatch() {
      try {
        this.validate();
        if (!this.canSubmit) throw new Error("请选择有效的修改方式");
        if (!this.previewCurrent) throw new Error("请先预览当前修改内容");
        if (!this.preview.selected_total || this.preview.total > 10000)
          throw new Error("候选商品需为1至10000件且不能全部排除");
      } catch (error) {
        return this.$message.warning(error.message);
      }
      const body = this.payload(),
        signature = JSON.stringify(body);
      this.confirming = true;
      try {
        const inventoryNotice = [
          "set_sku_timeliness",
          "set_mixed_stock",
        ].includes(this.shipping.operation)
          ? "本操作会调整现货与各预售时效库存，总库存可能增加，未选旧档将清零。"
          : this.shipping.operation === "set_presale" &&
            this.shipping.endMode === "none"
          ? "本操作会将总库存转入所选付款后时效，现货设为0。"
          : this.shipping.operation === "set_spot"
          ? "预售转现货保留当前现货数量，清空全部预售档，不合并预售库存。"
          : this.shipping.operation === "set_presale" &&
            this.shipping.endMode === "fixed"
          ? "若来源为新版混合商品，将按SKU合并现货及全部预售库存，原预售档清零，总库存保持不变。"
          : "";
        await this.$confirm(
          `将修改 ${this.preview.selected_total} 个商品的发货设置。${inventoryNotice}先核验店铺类目预售资格，不支持的自动跳过；平台将保存并提审。实际结果以平台回执为准，确定开始吗？`,
          "确认修改"
        );
        this.validate();
        if (signature !== JSON.stringify(this.payload()))
          throw new Error("设置已变化，请重新预览");
        this.frozenBody = body;
        await this.submitFrozen();
      } catch (error) {
        if (error !== "cancel" && error !== "close")
          this.$message.error(this.message(error));
      } finally {
        this.confirming = false;
      }
    },
    async submitFrozen() {
      if (this.submitting || !this.frozenBody) return;
      this.submitting = true;
      try {
        this.dataOf(await createDoudianShippingModeBatch(this.frozenBody));
        this.createUncertain = false;
        this.$message.success("任务已创建，请查看批量修改记录");
        this.$emit("created");
      } catch (error) {
        this.createUncertain = !error?.response && !error?.businessFailure;
        this.$message.error(
          this.createUncertain
            ? "创建结果待核实，请点击确认创建结果；系统将复用同一请求"
            : this.message(error)
        );
      } finally {
        this.submitting = false;
      }
    },
    exclude(id, checked) {
      const n = Number(id);
      this.excluded = checked
        ? [...new Set([...this.excluded, n])]
        : this.excluded.filter((x) => x !== n);
      this.invalidate();
    },
    resetFilters() {
      this.filters = defaults();
      this.selected = [];
      this.excluded = [];
      this.idsText = "";
      this.invalidate();
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id);
    },
    productTitle(item) {
      return item.product_title || item.title || "";
    },
    productImage(item) {
      return item.main_image || item.img || "";
    },
    productPrice(item) {
      return item.product_price == null
        ? "价格待定"
        : "¥" + Number(item.product_price).toFixed(2);
    },
    isSelected(item) {
      return this.draftSelected.some(
        (x) => this.productId(x) === this.productId(item)
      );
    },
    openSelector() {
      this.draftSelected = [...this.selected];
      this.selectorTab = "all";
      this.selectorVisible = true;
      this.loadSelector(1);
    },
    closeSelector() {
      this.selectorRequest++;
      this.selectorVisible = false;
      this.selectorLoading = false;
    },
    toggleProduct(item) {
      if (
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(item.shop_id) !== Number(this.draftSelected[0].shop_id)
      )
        return this.$message.warning("只能选择同一家店铺的商品");
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter(
            (x) => this.productId(x) !== this.productId(item)
          )
        : [...this.draftSelected, item];
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected);
      this.selectorRows.forEach((x) => {
        if (this.isSelected(x) === all) this.toggleProduct(x);
      });
    },
    changeSelectorTab(tab) {
      this.selectorRequest++;
      this.selectorLoading = false;
      this.selectorTab = tab;
      this.changeSelectorPage(1);
    },
    changeSelectorPage(page) {
      const p = Math.max(1, Math.min(this.selectorPages, Number(page) || 1));
      if (this.selectorTab === "all") this.loadSelector(p);
      else {
        this.selectorPage = p;
        this.selectorJump = p;
      }
    },
    confirmSelected() {
      if (
        this.draftSelected.some(
          (x) => Number(x.shop_id) !== Number(this.draftSelected[0].shop_id)
        )
      )
        return this.$message.warning("只能选择同一家店铺的商品");
      this.selected = [...this.draftSelected];
      this.closeSelector();
      this.excluded = [];
      this.invalidate();
    },
    async loadSelector(page) {
      const request = ++this.selectorRequest,
        shopId = this.selectorShopId;
      this.selectorLoading = true;
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            ...this.selectorFilters,
            page,
            page_size: this.selectorPageSize,
            ...(shopId ? { shop_ids: [shopId] } : {}),
          })
        );
        if (
          request !== this.selectorRequest ||
          shopId !== this.selectorShopId ||
          this._isDestroyed
        )
          return;
        this.selectorRows = data.list || [];
        this.selectorPage = page;
        this.selectorJump = page;
        this.selectorTotal = Number(data.pagination?.total || data.total || 0);
      } catch (error) {
        if (request === this.selectorRequest && !this._isDestroyed)
          this.$message.error(this.message(error));
      } finally {
        if (request === this.selectorRequest && !this._isDestroyed)
          this.selectorLoading = false;
      }
    },
  },
};
</script>

<style scoped src="./batch-modify.css"></style>
<style scoped>
.shipping-editor {
  display: grid;
  gap: 14px;
  padding-top: 16px;
  color: #1a1a2e;
  font-size: 12px;
}
.shipping-editor ::v-deep .el-radio__label,
.shipping-editor ::v-deep .el-checkbox__label {
  padding-left: 8px;
  font-family: inherit;
  font-size: 12px;
  line-height: 18px;
}
.shipping-editor ::v-deep .el-input__inner {
  font-family: inherit;
  font-size: 11px;
}
.shipping-editor ::v-deep .el-input-number {
  width: 120px;
  line-height: 26px;
}
.shipping-editor ::v-deep .el-input-number .el-input__inner {
  padding: 0 28px;
  text-align: center;
}
.shipping-editor ::v-deep .el-input-number__decrease,
.shipping-editor ::v-deep .el-input-number__increase {
  width: 26px;
  font-size: 12px;
  line-height: 26px;
}
.shipping-editor .el-radio,
.shipping-editor .el-checkbox {
  margin-right: 0;
  font-weight: 500;
}
.shipping-method-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
}
.shipping-method {
  min-width: 0;
  display: grid;
  gap: 12px;
}
.shipping-method-title {
  margin-right: 0;
}
.shipping-method-title ::v-deep .el-radio__label {
  font-weight: 600;
}
.shipping-method-options {
  min-width: 0;
  margin-left: 80px;
  display: grid;
  gap: 10px;
  font-size: 12px;
  line-height: 18px;
}
.shipping-field-row {
  min-width: 0;
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  align-items: start;
  gap: 8px 10px;
}
.shipping-field-label {
  text-align: right;
  line-height: 28px;
}
.shipping-presale-options {
  display: grid;
  gap: 10px;
}
.shipping-presale-line {
  min-width: 0;
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  gap: 8px;
}
.shipping-presale-line > .el-radio {
  line-height: 28px;
}
.shipping-presale-line .el-date-editor {
  width: 190px;
  max-width: 100%;
}
.shipping-row .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.shipping-time-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(104px, 1fr));
  gap: 4px 12px;
  width: 100%;
  max-width: 650px;
  line-height: 28px;
}
.shipping-holiday-times .el-date-editor {
  width: 210px;
  max-width: 100%;
}
.shipping-rule-help {
  color: #967025;
  cursor: help;
}
.shipping-tier-options,
.shipping-stock-options {
  display: grid;
  gap: 10px;
}
.shipping-tier-options {
  padding-left: 22px;
}
.shipping-row {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}
.shipping-capability-results {
  display: grid;
  gap: 6px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fafbfc;
  color: #606266;
  font-size: 12px;
}
.shipping-capability-heading {
  color: #303133;
  font-weight: 600;
}
.shipping-capability-item {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
}
.shipping-capability-item strong {
  min-width: 112px;
  color: #606266;
}
.shipping-capability-status {
  font-weight: 600;
}
.shipping-capability-status.conditional {
  color: #198754;
}
.shipping-capability-status.unsupported {
  color: #d93025;
}
.shipping-capability-status.unknown {
  color: #b7791f;
}
.shipping-capability-results .hint {
  margin: 2px 0 0;
}
.shipping-row .el-select {
  width: 160px;
  max-width: 100%;
}
.shipping-tiers {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: start;
  gap: 18px 24px;
  max-width: 1000px;
}
.shipping-tier {
  min-width: 0;
  display: grid;
  gap: 10px;
}
.shipping-tier > .el-checkbox {
  line-height: 28px;
}
.shipping-tier .el-input-number {
  width: 100px;
}
@media (max-width: 1200px) {
  .shipping-method-options {
    margin-left: 40px;
  }
  .shipping-tiers {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 800px) {
  .shipping-method-options {
    margin-left: 22px;
  }
  .shipping-tiers {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 500px) {
  .shipping-method-options {
    margin-left: 16px;
  }
  .shipping-field-row,
  .shipping-presale-line {
    grid-template-columns: minmax(0, 1fr);
  }
  .shipping-field-label {
    text-align: left;
  }
}

.preview-product-image {
  object-fit: cover;
}
</style>
